import useSchools from './useSchools';

export { useSchools };
